<template>
  <div class="defaultcard">
    <v-saveprice
      v-if="computed_price.agio > 0"
      :saveprice="computed_price.agio"
    ></v-saveprice>
    <a
      :href="variant_src_id ?(`${productDetail.path}?variant=${variant_src_id}`||`${productDetail.public_url}?variant=${variant_src_id}`): (productDetail.path || productDetail.public_url)"
      class="product_card_backgorund"
      :class="[classtype,themeStyleRadius == 'circle' ? 'image-radius' : '']"
    >
      <div class="img-wrap" :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']" style="overflow: hidden;">
        <v-product-tag 
          v-if="$store.state.product_tag_list[productDetail.ID]" 
          :productTag="$store.state.product_tag_list[productDetail.ID]"
          :productInfo="{...product_info,stock:stock_count,sku:sku}"></v-product-tag>
        <v-lazy-img 
          :src="mainImg.thumbnail || (mix_now_image_data && mix_now_image_data.thumbnail)"
          :dataUrl="mainImg.url || (mix_now_image_data && mix_now_image_data.url)"
          ></v-lazy-img>
      </div>
      <v-custom-button  v-if="custom_button&&custom_button.is_card=='1'" model="is_card" :custom_button='custom_button'></v-custom-button>
      <span class="fallback-text page_text_font">{{productDetail.post_title}}</span>
    </a>
    <a
      :href="variant_src_id ?(`${productDetail.path}?variant=${variant_src_id}`||`${productDetail.public_url}?variant=${variant_src_id}`): (productDetail.path || productDetail.public_url)"
      class="intro"
    >
      <span class="intro_name page_text_font">{{productDetail.post_title}}</span>
      <v-product-palette
        type="card"
        v-if="
          palette_config &&
          $store.state.product_palette_list[productDetail.ID] &&
          $store.state.product_palette_list[productDetail.ID].length
        "
        :palette_attrs="[
          $store.state.product_palette_list[productDetail.ID][0]
        ]"
        :variant_attrs="variant"
        :palette_config="palette_config"
        :mouse_enter="true"
        :url="productDetail.path || productDetail.public_url"
      ></v-product-palette>
      <p>
        <!-- <span class="iconfont icon-jian"></span> -->
        <v-selectprice :price="productDetail.min_price" :disable_select="!(showCurrencySelector && currencySelectorType == 'global')" :appendToBody="false"></v-selectprice>
        <!-- <span class="iconfont icon-jia"></span> -->
      </p>
    </a>
  </div>
</template>

<script>
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import vProductPalette from '@/js/components/view/productpalette/index.vue'
import mixProductTag from '@/js/mixins/mixProductTag'
import { mapState } from 'vuex';
import mixProduct from "@/js/mixins/mixProduct"

export default {
  props: ["productDetail", "classtype", "imgsize", "palette_config",'custom_button','isShowMainImg'],
  data() {
    return {
      selected_variant: [],
      palette_img: "",
      variant_src_id: null,
      product:{},
      price: 0, //产品卡片标签的价格
      regularPrice: 0,//产品卡片标签的原价格
      sku:"",//产品卡片标签的SKU
      stock_count:0 //产品卡片标签的库存数
    };
  },
  mixins:[mixProductTag,mixProduct],
  computed:{
    ...mapState({
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type,
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    })
  },
  beforeMount() {
    this.product = this.productDetail;
    this.price = this.productDetail?.variants_detail[0]?.min_price || this.productDetail?.min_price || 0;
    this.regularPrice = this.productDetail?.variants_detail[0]?.regular_price || this.productDetail?.regular_price || 0;
    this.sku = this.productDetail?.variants_detail[0]?.sku || this.productDetail?.sku || 0;
    this.stock_count = this.productDetail?.variants_detail[0]?.stock || this.productDetail?.stock || 0;
  },
  components: {
    vProductTag,
    vProductPalette,
  },
};
</script>

<style scoped  lang='scss'>
.defaultcard {
  position: relative;
  .img-wrap{
    width: 90%;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
  .thumbnail {
    min-height: 255px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9f1e6;
    padding: 20px 0;
    margin: 0;
    overflow: hidden;
    position: relative;
    img {
      max-height: 215px;
      max-width: 100%;
    }
    &:hover {
      opacity: 0.9;
    }
  }
  .bigphoto {
    min-height: 580px;
    padding: 20px 0;
    background: #f9f1e6;
    display: flex;
    justify-content: center;
    align-items: center;

    img{
      max-height: 540px;
      max-width: 100%;
      &:hover {
        opacity: 0.9;
      }
    }
    // &:hover {
    //   transition: opacity 0.15s ease-in;
    //   opacity: 0.9;
    // }
  }

  a {
    border: none;
  }

  .intro {
    display: block;
    text-decoration: none;
    text-align: center;
    color: black;
    font-size: 1.2em;
    padding-top: 13px;
    margin-bottom: 15px;
    padding-bottom: 15px;
    p {
      margin: 0;
      // display: inline-block;
      span {
        font-size: 14px;
        color: black;
        font-weight: 600;
      }
    }
  }
  ::v-deep {
    .selectpricewrap {
      .pricelist {
        z-index: 99;
      }
    }
    .saveprice {
      z-index: 98;
    }
  }
}
@media screen and (max-width: 992px) {
  .defaultcard {
    .thumbnail {
      min-height: 165px !important;

      img {
        max-height: 205px !important;
      }
    }

    .bigphoto {
      min-height: 480px !important;

      img {
        max-height: 440px !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .defaultcard {
    .thumbnail {
      min-height: 115px !important;

      img {
        max-height: 155px !important;
      }
    }

    .bigphoto {
      min-height: 440px !important;

      img {
        max-height: 400px !important;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .defaultcard {
    .thumbnail {
      min-height: 335px !important;
      height: 335px !important;

      img {
        max-height: 295px !important;
      }
    }

    .bigphoto {
      min-height: 335px !important;
      height: 335px !important;

      img {
        max-height: 295px !important;
      }
    }
  }
}
</style>
